<template>

  <div>
    <md-autocomplete  v-model="term"
                     @md-selected="handleItemSelected"
                     :md-options="getOptions"
                     >
      <label v-if="label">{{label}}</label>

      <template  slot="md-autocomplete-item" slot-scope="{ item, term }">
        <md-tooltip class = "custList" md-delay="50">{{ item.name }} ({{item.id}})</md-tooltip>
        <md-highlight-text class = "custList" :md-term="term">{{ item.name }} ({{item.id}})</md-highlight-text>
      </template>

      <template slot="md-autocomplete-empty" slot-scope="{ term }">
        No item matching "{{ term }}" were found.
      </template>

    </md-autocomplete>

    <div>
      <md-chip v-for="item in getSelectedItems" @click="handleItemDeleted(item.id)" md-deletable @md-delete="handleItemDeleted(item.id)">
        {{item.name}}({{item.id}})
      </md-chip>
    </div>

  </div>


</template>

<style scoped>

.custList {
  width: 300px;
}


</style>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      value: Array,
      label: String,
      group: String,
      onSelectedItemIdsChanged: Function,
      initSelectedIds: Array,
      preparedOptions: Array,
    },
    data: () => ({
      selectedItemIds: [],
      term: '',
    }),
    computed: {
      getOptions() {
        if (this.preparedOptions) {
          return this.preparedOptions;
        }
        return this.getMasterDataAsSelectOptionByGroup(this.group);
      },
      getSelectedItems() {
        return _(this.getOptions).filter((it) => {
          return _(this.selectedItemIds).contains(it.id);
        });
      },
      ...mapGetters([
        'getMasterDataAsSelectOptionByGroup',
        'getMasterDataName',
      ]),
    },
    watch: {
      selectedItemIds(val) {
        this.$emit('input', val);
        if (this.onSelectedItemIdsChanged && _.isFunction(this.onSelectedItemIdsChanged)) {
          this.onSelectedItemIdsChanged(val);
        }
      },
      value(val) {
        if (this.selectedItemIds !== val) {
          this.selectedItemIds = val;
        }
      },
    },
    mounted() {
      this.$nextTick(() => {
        if (this.initSelectedIds) {
          this.selectedItemIds = this.initSelectedIds;
        } else if (this.value) {
          this.selectedItemIds = this.value;
        }
      });
    },
    methods: {
      clear() {
        console.log(`clear`);
        this.term = '';
        this.selectedItemIds = [];
      },
      handleItemSelected(item) {
        console.log(`handleItemSelected`, item.id);
        this.selectedItemIds.push(item.id);
        this.selectedItemIds = _(this.selectedItemIds).uniq();
        this.term = '';
        this.$nextTick(() => {
          this.term = '';
        });
      },
      handleItemDeleted(itemId) {
        console.log(`handleItemDeleted`, itemId);
        this.selectedItemIds = _(this.selectedItemIds).without(itemId);
      }
    },
  };
</script>
